import { Label } from "@/components/ui/label";
import type { FieldRendererProps } from "./index";

export function CheckboxField({ label, required, properties, disabled }: FieldRendererProps) {
  const options = properties.options ?? [];

  return (
    <div className="space-y-2">
      <Label>
        {label}
        {required && <span className="ml-1 text-destructive">*</span>}
      </Label>
      <div className="space-y-2">
        {options.map((opt) => (
          <label key={opt.value} className="flex items-center gap-2 text-sm">
            <input type="checkbox" disabled={disabled} className="rounded" />
            {opt.label}
          </label>
        ))}
      </div>
    </div>
  );
}
